export const requestIdleCallback = (callback: () => void, timeout = 0): void => {
    if ('requestIdleCallback' in window) {
        window.requestIdleCallback(callback, { timeout });

        return;
    }

    setTimeout(callback, timeout);
};
